import './App.css';
import Routes from './routes/Routes';
import { useSelector, useDispatch } from 'react-redux';
// import MessengerCustomerChat from 'react-messenger-customer-chat';
import React, { useEffect } from 'react';
import { userLogout } from './store/user';
import { adminLogout, stopImpersonation, IMPERSONATION_END_REASONS } from './store/admin';
import ImpersonationBanner from './components/ImpersonationBanner';
import { decodeJwtExpiration } from './helpers/jwt';

// import resolveConfig from 'tailwindcss/resolveConfig';
// import tailwindConfigModule from '../tailwind.config.js';
import { ThemeProvider, createTheme } from '@mui/material';

// import ReactGA from './helpers/analytics'; // need this here even if we don't use it.

// Send pageview with a custom path
// ReactGA.send({ hitType: "pageview", page: "/", title: "Home Page" });

// import ReactGA from "./helpers/analytics";
import ReactGA from 'react-ga4';

const trackingId = 'G-CPSC7Z0WT4'; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);
//

// Send pageview with a custom path
ReactGA.send({ hitType: 'pageview', page: '/', title: 'Custom Title' });

// const tailwindConfig = resolveConfig(tailwindConfigModule);
const theme = createTheme({
	palette: {
		primary: { main: '#CC1DB9' }, //pink
		// secondary: { main: "#1DB9CC" }, //teal
		secondary: { main: '#3CACAE' }, //teal
		fadedSecondary: { main: '#D8EEEE' }, //faded teal
		tertiary: { main: '#CC881D' }, //gold
		quarternary: { main: '#1D61CC' }, // blue
		quinary: { main: '#1DCC30' }, //green
		senary: { main: '#B9CC1D' },
		septenary: { main: '#F9FAFB' }, //white
		octonary: { main: '#6B7280' }, //grey
	},
	//using tailwind breakpoints in material UI.  Added extra iphone break point
	breakpoints: {
		values: {
			xs: 0,
			iphone: 375,
			sm: 640,
			md: 768,
			lg: 1024,
			xl: 1280,
			xxl: 1536,
		},
	},
});

function App() {
	const dispatch = useDispatch();

	const currentUser = useSelector((st) => st.user.currentUser);
	const currentAdmin = useSelector((st) => st.admin.currentAdmin);
	const adminRemember = useSelector((st) => st.admin.remember);
	const activeUsername = useSelector((st) => st.user.activeUsername);
	// Multi-account (#168): keep every account on tab close if ANY of them asked
	// to be remembered; `user.remember` alone is only the choice for the next login.
	const effectiveUserRemember = useSelector((st) => {
		const accounts = Array.isArray(st.user.accounts) ? st.user.accounts : [];
		return accounts.length ? accounts.some((a) => a.remember) : st.user.remember;
	});
	const isImpersonating = useSelector((st) => st.admin.isImpersonating);
	const impersonatedToken = useSelector((st) => st.admin.impersonatedToken);

	/** Session management: handle "remember me" via sessionStorage sentinel.
	 *  sessionStorage persists across navigations (including Stripe checkout)
	 *  but clears when the browser tab/window is closed.
	 */
	useEffect(() => {
		if (!effectiveUserRemember && !sessionStorage.getItem('jr_user_session')) {
			dispatch(userLogout());
		}
		if (!adminRemember && !sessionStorage.getItem('jr_admin_session')) {
			dispatch(adminLogout());
		}

		if (currentUser?.username && !effectiveUserRemember) {
			sessionStorage.setItem('jr_user_session', 'active');
		}
		if (currentAdmin?.username && !adminRemember) {
			sessionStorage.setItem('jr_admin_session', 'active');
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// Keep sentinels in sync with auth state
	useEffect(() => {
		if (currentUser?.username && !effectiveUserRemember) {
			sessionStorage.setItem('jr_user_session', 'active');
		} else if (!currentUser?.username) {
			sessionStorage.removeItem('jr_user_session');
		}
	}, [currentUser?.username, effectiveUserRemember]);

	useEffect(() => {
		if (currentAdmin?.username && !adminRemember) {
			sessionStorage.setItem('jr_admin_session', 'active');
		} else if (!currentAdmin?.username) {
			sessionStorage.removeItem('jr_admin_session');
		}
	}, [currentAdmin?.username, adminRemember]);

	/** Validate persisted impersonation token on rehydration */
	useEffect(() => {
		if (!isImpersonating || !impersonatedToken) return;

		const expirationTime = decodeJwtExpiration(impersonatedToken);
		if (expirationTime === null) {
			// Malformed or missing exp — treat as expired
			dispatch(stopImpersonation(IMPERSONATION_END_REASONS.EXPIRED));
			return;
		}
		if (expirationTime - Date.now() < 30000) {
			dispatch(stopImpersonation(IMPERSONATION_END_REASONS.EXPIRED));
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<ThemeProvider theme={theme}>
			<div className='App'>
				<ImpersonationBanner />
				<div className={isImpersonating ? 'pt-16' : ''}>
					{/* Remount on account switch so no component keeps the previous account's local state */}
					<Routes key={activeUsername || 'anon'} />
				</div>
				{/* <MessengerCustomerChat pageId="114425623304645" appId="397024515130926" /> */}
			</div>
		</ThemeProvider>
	);
}

export default App;
